<template>
  <div>
    <div class="dropdown-center d-grid">
      <button class="btn btn-primary btn-lg dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
        {{ title }}
      </button>
      <ul class="dropdown-menu">
        <div v-for="(option, index) in extra.options" :key="index">
          <li v-if="index !== 0"><hr class="dropdown-divider"></li>
          <li><button class="dropdown-item" @click="controlData(option.value)">{{ option.title }}</button></li>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'extra'],
  data () {
    return {
      msgId: null
    }
  },
  sockets: {
    controlDataStatus: function (data) {
      if (data.msgId === this.msgId) {
        this.$swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Käsklus edastatud!',
          showConfirmButton: false,
          timer: 1500
        })
      }
    }
  },
  methods: {
    controlData (value) {
      this.msgId = Date.now()
      console.log('controlData', this.extra.serial, value)
    }
  }
}
</script>
